import { MenuItem } from './MobileMenu'

export const menuItems: MenuItem[] = [
  {
    label: 'Car finance',
    path: '/car-finance/',
    subItems: [
      { label: 'Bad Credit Car Finance', path: '/bad-credit-car-finance/' },
      { label: 'HP Car Finance', path: '/hp-car-finance/' },
      { label: 'PCP Car Finance', path: '/pcp-car-finance/' },
      { label: 'No Deposit Car Finance', path: '/no-deposit-car-finance/' },
      { label: 'Electric Car Finance', path: '/electric-car-finance/' },
      {
        label: 'Negative Equity Car Finance',
        path: '/negative-equity-car-finance/'
      },
      { label: 'Refinance Car', path: '/refinance-car/' },
      { label: 'Van Finance', path: '/van-finance/' },
      { label: 'Motorbike Finance', path: '/motorbike-finance/' },
      { label: 'Used Car Finance', path: '/used-car-finance/' },
      { label: 'Self-Employed Car Finance', path: '/self-employed-car-finance/' }
    ]
  },
  {
    label: 'Car finance calculator',
    path: '/car-finance-calculator/'
  },
  {
    label: 'Car finance explained',
    path: '/car-finance-explained/'
  },
  {
    label: 'FAQs and guides',
    path: '/faqs-and-guides/',
    subItems: [
      { label: 'Blog', path: '/blog/' },
      { label: 'FAQs', path: '/help-and-advice/' },
      { label: 'Car finance glossary', path: '/car-finance-glossary/' }
    ]
  },
  {
    label: 'Contact us',
    path: '/contact-us/'
  }
]
